module.exports = __webpack_public_path__ + "b4de1451edf5e95ed0c616c99380a533.jpg";